import { validatePhoneNumber } from "ui/Input/PhoneInput"
import { AVAILABILITY_TYPES } from "./constants"

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const validateProfileFields = (formData, t) => {
  const errors = {}

  if (!formData.firstName?.trim()) {
    errors.firstName = t("staff.add_staff_modal.validation.first_name_required") || "First name is required"
  }

  if (!formData.lastName?.trim()) {
    errors.lastName = t("staff.add_staff_modal.validation.last_name_required") || "Last name is required"
  }

  if (!formData.email?.trim()) {
    errors.email = t("staff.add_staff_modal.validation.email_required") || "Email is required"
  } else if (!EMAIL_REGEX.test(formData.email)) {
    errors.email = t("staff.add_staff_modal.validation.email_invalid") || "Please enter a valid email address"
  }

  if (!formData.permissionRole) {
    errors.permissionRole = t("staff.add_staff_modal.validation.role_required") || "Permission role is required"
  }

  if (!formData.description?.trim()) {
    errors.description = t("staff.add_staff_modal.validation.description_required") || "Description is required"
  }

  return errors
}

const validatePhone = async (phone, t) => {
  if (!phone?.trim()) {
    return t("staff.add_staff_modal.validation.phone_required") || "Phone number is required"
  }

  try {
    await validatePhoneNumber(phone)
    return null
  } catch (error) {
    return t("staff.add_staff_modal.validation.phone_invalid") || "Please enter a valid phone number"
  }
}

const validateExperiences = (experiences, t) => {
  if (!experiences || experiences.length === 0) {
    return t("staff.add_staff_modal.validation.experience_required") || "At least one experience must be assigned"
  }
  return null
}

const validateAllYearAvailability = (formData, selectedDays, t) => {
  const errors = {}

  if (!selectedDays || selectedDays.length === 0) {
    errors.selectedDays = t("staff.add_staff_modal.validation.days_required") || "At least one day must be selected"
  }

  return errors
}

const validateSeasonalAvailability = (formData, seasons, t) => {
  const errors = {}

  const visibleSeasons = seasons.filter((season) => !season._destroy)

  if (visibleSeasons.length === 0) {
    errors.seasons = t("staff.add_staff_modal.validation.season_required") || "At least one season must be added"
  } else {
    const hasInvalidSeason = visibleSeasons.some((season) => {
      if (!season.from || !season.to) return true
      if (!season.selectedDays || season.selectedDays.length === 0) return true
      return false
    })

    if (hasInvalidSeason) {
      errors.seasons =
        t("staff.add_staff_modal.validation.season_incomplete") ||
        "All seasons must have dates and selected days"
    }
  }

  return errors
}

export const validateStaffForm = async ({ formData, selectedDays, seasons }, t) => {
  const errors = {}

  Object.assign(errors, validateProfileFields(formData, t))

  const phoneError = await validatePhone(formData.phone, t)
  if (phoneError) {
    errors.phone = phoneError
  }

  const experiencesError = validateExperiences(formData.experiences, t)
  if (experiencesError) {
    errors.experiences = experiencesError
  }

  if (formData.availability === AVAILABILITY_TYPES.ALL_YEAR) {
    Object.assign(errors, validateAllYearAvailability(formData, selectedDays, t))
  } else if (formData.availability === AVAILABILITY_TYPES.SEASONAL) {
    Object.assign(errors, validateSeasonalAvailability(formData, seasons, t))
  }

  return errors
}
